export const buildGuestNotificationItems = ({ announcements = [], claims = [], directThreads = [], userId, language = 'es' }) => {
  const unreadAnnouncements = announcements.filter(a => !a.read_by?.includes(userId));
  const activeClaims = claims.filter(c => c.status !== 'closed' && Number(c.unread_count || 0) > 0);
  const unreadDirectThreads = directThreads.filter(thread => (thread.unread_guest || 0) > 0);

  return [
    ...unreadAnnouncements.map(a => ({
      kind: 'announcement', id: a.id, title: a.title, body: a.content, at: a.created_at,
    })),
    ...activeClaims.map(c => ({
      kind: 'claim', id: c.id, status: c.status, claim_type: c.claim_type,
      title: c.status === 'resolved'
        ? (language === 'es' ? `Reclamo resuelto: ${c.title}` : `Claim resolved: ${c.title}`)
        : (language === 'es' ? `Reclamo en progreso: ${c.title}` : `Claim in progress: ${c.title}`),
      body: c.last_message_text || c.admin_response || c.description,
      at: c.updated_at || c.created_at, unreadCount: Number(c.unread_count || 0),
    })),
    ...unreadDirectThreads.map(thread => ({
      kind: 'direct-message', id: thread.id, thread,
      title: language === 'es' ? 'Mensaje de Administración' : 'Message from Administration',
      body: thread.last_message_text, at: thread.last_message_at, unreadCount: thread.unread_guest,
    })),
  ].sort((a, b) => new Date(b.at) - new Date(a.at)).slice(0, 12);
};

export const getGuestNotificationUnreadCount = (items = []) => items.reduce(
  (total, item) => total + (item.kind === 'announcement' ? 1 : Number(item.unreadCount || 0)),
  0,
);
